import React from 'react';

const NotFound = () => {
    return (
        <div className='mt-28'>

            <h1 className='text-red-600 text-8xl font-bold mb-4'>404</h1>
            <h2 className='text-red-600 text-5xl font-bold mb-4'>Sorry!!!</h2>
            <h3 className='text-red-600 text-2xl font-bold'>The page is not Found</h3>

        </div>
    );
};

export default NotFound;